var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRearrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 13.1053 7.89474 14 9 14C10.1053 14 11 13.1053 11 12C11 10.8947 10.1053 10 9 10C7.89474 10 7 10.8947 7 12ZM14 12C14 13.1053 14.8947 14 16 14C17.1053 14 18 13.1053 18 12C18 10.8947 17.1053 10 16 10C14.8947 10 14 10.8947 14 12ZM7 5C7 6.10526 7.89474 7 9 7C10.1053 7 11 6.10526 11 5C11 3.89474 10.1053 3 9 3C7.89474 3 7 3.89474 7 5ZM14 5C14 6.10526 14.8947 7 16 7C17.1053 7 18 6.10526 18 5C18 3.89474 17.1053 3 16 3C14.8947 3 14 3.89474 14 5ZM7 19C7 20.1053 7.89474 21 9 21C10.1053 21 11 20.1053 11 19C11 17.8947 10.1053 17 9 17C7.89474 17 7 17.8947 7 19ZM14 19C14 20.1053 14.8947 21 16 21C17.1053 21 18 20.1053 18 19C18 17.8947 17.1053 17 16 17C14.8947 17 14 17.8947 14 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRearrange);
export default __webpack_public_path__ + "static/media/rearrange.493e0a06.svg";
export { ForwardRef as ReactComponent };